<template>
    <div
        class="relative"
        :style="'min-height:' + minHeight"
    >
        <div
            ref="container"
            v-click-outside="{
                when: isOpen,
                callback: close,
                whitelist,
            }"
            :class="{ 'md:sticky': isOpen }"
            class="w-full z-[41]"
        >
            <slot></slot>

            <transition name="bounce">
                <keep-alive>
                    <div
                        v-if="screenSize === 'small' && isOpen"
                        class="fixed bg-white inset-0 z-50 md:hidden"
                    >
                        <slot name="mobile"></slot>
                    </div>
                </keep-alive>
            </transition>
        </div>
        <transition name="fade">
            <div
                v-if="isOpen"
                class="fixed bg-black opacity-20 w-full h-full inset-0 z-40 hidden md:block"
            ></div>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PopupOverlay',

    props: {
        /* ids or classes to allow clicks on */
        whitelist: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['close'],

    data() {
        return {
            isOpen: false,
            minHeight: 'auto',
        };
    },

    computed: {
        ...mapGetters('ui', ['screenSize']),
    },

    beforeUnmount() {
        if (this.isOpen) {
            this.close();
        }
    },
    methods: {
        open() {
            const height = this.$refs.container.clientHeight + 2;
            this.minHeight = `${height}px`;
            this.isOpen = true;
            document.body.classList.add('is-popup-overlay', 'overflow-hidden', 'md:overflow-auto');
        },
        close() {
            this.isOpen = false;
            this.minHeight = 'auto';
            document.body.classList.remove('overflow-hidden', 'md:overflow-auto', 'is-popup-overlay');
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
.bounce-enter-active,
.bounce-leave-active {
    transition: all 0.25s ease-in-out;
}

.bounce-enter-from,
.bounce-leave-to {
    opacity: 0;
    transform: scale(0.3) translate3d(0, 0, 0);
}

.bounce-leave-from,
.bounce-enter-to {
    transform: scale(1) translate3d(0, 0, 0);
}
</style>
